const cookieUiTexts = {
	popupText: 'Vi bruger cookies til at forbedre din spiloplevelse. Ved at klikke på \'OK\' eller logge ind accepterer du vores brug af cookies.',
	popupBtn: 'Ok',
};

const errorUiTexts = {
	unknownError: 'Fejl: Ukendt fejl.',
	/* Create user (facilitator) */
	emptyFields: 'Du skal udfylde alle felter.',
	emailExists: 'Der findes allerede en bruger med denne email.',
	invalidPassword: 'Dit password skal være på mindst 8 tegn.',
	noPasswordMatch: 'Password skal være ens i begge felter.',
	userNotAllowed: 'Denne e-mail er ikke godkendt.',
	userAlreadyCreated: 'Denne e-mail er allerede i brug.',
	/* Login / reset password (facilitator) */
	invalidSchool: 'Ugyldig skole.',
	invalidPassword: 'Ugyldigt password.',
	invalidEmail: 'Din email er ikke gyldig.',
	userNotFound: 'Brugeren findes ikke i systemet.',
	/* Login (group) */
	noGameCodeMatch: 'Ugyldig spilkode.',
	/* Create group */
	invalidCharacters: 'Navnet indeholder et eller flere ugyldige tegn.',
	groupNameTooShort: 'Gruppenavn skal være på mindst 3 tegn.',
	groupNameTooLong: 'Gruppenavn må ikke være længere end 15 tegn.',
	noGroupName: 'Husk at udfylde et gruppenavn.',
	groupNameAlreadyExists: 'Der eksisterer allerede en gruppe med det navn.',
	
	/* Create Game */
	createGameError: 'Fejl i oprettelse af spil',
	noQRUrl: 'Et eller flere af de valgte spil mangler en QR url',

	/* School */
	schoolNameExists: 'Der findes allerede en skole med det navn.',
	couldNotGetSchool: 'Kunne ikke finde skole',
	imageTooLarge: 'Billedet er for stort. Maksimal størrelse er 1MB.',

	/* Game Data */
	noGameData: 'game data not found',
	noGameDataDatabase: 'Error: Game data not in database.',
};

const loginUiTexts = {
	welcome: 'Velkommen til',
	loading: 'Loading',
	schoolLogin: 'SKOLE',
	adminLogin: 'Admin',
	superAdminLogin: 'Super admin',
	groupLogin: 'ELEV',
	gameCode: 'Kodeord',
	groupLoginIntruction: 'Når din lærer opretter et spilforløb, genereres en unik spilkode.',
	login: 'Log ind',
	newGroup: 'Ny gruppe',
	writeGroupName: 'Skriv gruppenavn',
	groupName: 'Gruppenavn',
	create: 'Opret',
	cancel: 'Afbryd',
	email: 'E-mail',
	password: 'Password',
	repeatPassword: 'Gentag password',
	logout: 'Log ud',
	createNewUser: 'Opret ny bruger',
	create: 'Opret',
	newUserCreated: 'Din bruger er blevet oprettet, du kan nu logge ind.',
	backToLogin: 'Tilbage til login',
	resetPassword: 'Nulstil password',
	reset: 'Nulstil',
	passwordIsReset: 'Du har fået tilsendt en e-mail med et link til at nulstille dit password.',
	loggedInAs: 'Logget ind som',
	useGameCode: 'Indtast spilkoden:',
	loggingIn: 'Logger ind ...',
	loadingGame: 'Henter spil ...',
};

const adminUiTexts = {
	admin: 'Admin',
	email: 'E-mail',
	status: 'Status',
	created: 'Oprettet',
	delete: 'Slet',
	addUser: 'Tilføj',
	backToGame: 'Tilbage',
	createSchool: 'Opret Skole',
	createSchoolPopup: {
		title: 'Opret skole',
		title2: 'Rediger skole',
		schoolName: 'Skolenavn',
		school: 'Skole',
		email: 'E-mail',
		password: 'Password',
		games: 'Spil',
		facilitatorSurvey: 'Evalueringslink til facilitator',
		questions: 'Spørgsmål',
		qrUrl: 'QR url',
		create: 'Opret',
		edit: 'Rediger',
		save: 'Gem',
		unlimited: 'Ubegrænset',
		linkToShortHTX: 'HTX Quick Game',
		linkToShortHHX: 'HHX Quick Game',
		schoolBackgroundImage: 'Baggrundsbillede',
		max1Mb: 'Maks. 1MB',
		currentImage: 'Nuværende billede',
		customArea: 'Custom område'
	},
	deleteSchoolPopup: {
		title: 'Slet skole',
		text: 'Er du sikker på, at du vil slette skolen "%school%"?',
		confirmDelete: 'Slet skole',
		cancelDelete: 'Fortryd',
	},
	resetSchoolPopup: {
		title: 'Nulstil skole',
		text: 'Er du sikker på, at du vil nulstille antal elever / afviklinger for skolen "%school%"?',
		confirmBtn: 'Ja, nulstil',
		cancelBtn: 'Nej, fortryd'
	},
	schoolList: {
		school: 'SKOLE',
		email: 'E-MAIL',
		password: 'PASSWORD',
		status: 'STATUS',
		students: 'ELEVER',
		playthroughs: 'AFVIKLINGER',
		edit: 'REDIGER',
		reset: 'NULSTIL',
		delete: 'SLET',
	}
};

const schoolUiTexts = {
	admin: 'Admin',
	back: 'Tilbage',
	controlPanel: 'Kontrolpanel',
	goToControlPanel: 'Gå til kontrolpanel',
	linkToShortHTX: 'Elevspil Kort HTX',
	linkToShortHHX: 'Elevspil Kort HHX',
	gameCode: 'Spilkode',
	startGameBtn: 'Start spil',
	closeGameBtn: 'Afslut spil',
	countdownTimer: 'Countdown timer',
	leaderboard: 'Leaderboard',
	rank: 'Rank',
	name: 'Navn',
	points: 'Point',
	video: 'Video',
	distributeQuestionsRandomly: 'Uddel spørgsmål tilfældigt',
	

	// Files
	supportAndExtra: 'Support og tilvalg',
	studentPresentation: 'Kickoff-præsentation',
	facilitatorGuide: 'Brugervejledning',

	/* Links */
	download: 'Download',
	viewSurveys: 'Se elevernes besvarelser',
	editContent: 'Ret i indhold',
	tryGames: 'Prøv spil',
	surveyLink: 'Evaluering',
	surveyLink2: 'Elevbesvarelser',
	editQuestionRound: 'Ret i spørgsmålsrunde',
	editQuestionaire: 'Ret i spørgeskema',
	otherFeedback: 'Feedback til Gymnasiespil',

	noAccessPage: {
		noAccess: 'Din skole, <b>%school%</b>, har ikke adgang til spillet %scenario%.'
	},
	landingPage: {
		createGame: 'Opret nyt spil',
		studentsField: 'Elever:',
		playThroughField: 'Afviklinger:',
		game: 'SPIL',
		gameCode: 'SPILKODE',
		choose: 'VÆLG',
		goToGame: 'Gå til spil',
		start: 'Start spil',
		continue: 'Fortsæt spil',
		viewResults: 'Se resultater',
		delete: 'SLET'
	},
	gameReadyPage: {
		group: 'Grupper',
	},
	deleteGamePopup: {
		title: 'Slet spil',
		text: 'Er du sikker på, du vil slette spillet "%game%"?',
		cancelBtn: 'Fortryd',
		confirmBtn: 'Slet spil',
	},
	noGroupsWarning: {
		title: 'Start spil',
		text: 'Der er ikke nogen grupper logget ind, er du sikker på, du vil starte spillet?',
		cancelBtn: 'Fortryd',
		confirmBtn: 'Start spil'
	},
	closeGameWarning: {
		title: 'Afslut spil',
		text: 'Er du sikker på at du vil afslutte spillet?',
		cancelBtn: 'Fortryd',
		confirmBtn: 'Afslut spil'
	},
	continueToEvaluationWarning: {
		title: 'Fortsæt til spørgeskema',
		text: 'Er du sikker på at du vil fortsætte til spørgeskemaet?',
		cancelBtn: 'Fortryd',
		confirmBtn: 'Fortsæt'
	},
	gameDonePage: {
		title: 'Final score',
		continueToQuestions: 'Fortsæt til spørgsmål',
		continueToEvaluation: 'Fortsæt til spørgeskema'
	},
	evaluationPage: {
		text: `I skal nu udfylde en evaluering.
			<br /><br />Det er vigtigt, at <strong>ALLE</strong> i gruppen nu logger ind via jeres egen computer eller telefon.
			<br /><br />Det kan gøres på to måder:
			<br /><br />1. Gå ind på %url%, log ind med %gameCode%, og tryk på evalueringslinket.
			<br />2. Scan QR-koden med jeres telefon for at gå direkte til evalueringen.
			<br /><br />Det har været en kæmpe fornøjelse at have jer med i dag!`
	}


};

const gameUiTexts = {
	resetBtn: 'Nulstil',
	backBtn: 'Tilbage',
	welcomeTo: 'Velkommen til',
	welcomeToGame: 'Velkommen til %game% på',
	welcomeToGameWith: 'Velkommen til %game% med',
	goToOffice: 'Gå ind på dit kontor',
	startGame: 'Start spillet',
	goInside: 'Start',
	timesOut: 'tiden er gået',
	hint: 'Hint',
	choose: 'Vælg',
	ok: 'OK',
	points: 'Point',
	handOver: 'Aflever',
	correctAnswer: 'Korrekt svar',
	gameNotBegun: 'Spillet er ikke begyndt endnu',
	gameOver: 'Spillet er slut',
	nextAssignment: 'Næste opgave',
	continueBtn: 'Videre',
	exitAssignments: 'Tilbage til kontoret',
	waitForFacilitator: 'Afvent, at facilitator fortsætter spillet.',
	chooseQuestionTitle: 'Vælg et spørgsmål, I vil stille',
	chooseQuestionText: 'Hvert spørgsmål kan kun vælges én gang af en gruppe.',
	thankYouForPlaying: 'Tak fordi du spillede',
	evaluation: 'Evaluering',
	qrCodeInfo: `I skal nu udfylde en evaluering.
		<br /><br />Det er vigtigt, at ALLE i gruppen nu logger ind på %url% via jeres egen computer og bruger spilkoden, som vises på smartboardet.
		<br /><br />Det kan gøres på to måder:
		<br /><br />1. Tryk på evaluerings linket herunder.
		<br />2. Scan QR-koden med din telefon for at gå direkte til evalueringen.
		<br /><br />Det har været en kæmpe fornøjelse at have jer med i dag!`
};

const generalUiTexts = {
}

export {
	cookieUiTexts,
	errorUiTexts,
	loginUiTexts,
	adminUiTexts,
	schoolUiTexts,
	gameUiTexts,
	generalUiTexts
};